import currency from 'currency.js';

export const formatCentsAsUSD = (cents: number) => {
  return currency(cents, {
    fromCents: true,
    format: (currency?: currency) => {
      if (currency.value % 1 != 0) {
        return `$${currency.dollars()}.${currency.cents()}`;
      } else {
        return `$${currency.dollars()}`;
      }
    },
  }).format();
};

export const formatCents = (cents: number, c: string) => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: c.toUpperCase(),
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(cents / 100);
};

export const getCurrencySymbol = (c: string) => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: c,
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(0)[0];
};
